export default __webpack_public_path__ + "static/media/Concussor.ab980ee0.jpg";